// extracted by mini-css-extract-plugin
export default {"layout":"dark_layout__PmkV-","stretchVertically":"dark_stretchVertically__pxaAd"};